// @mui material components
import Grid from "@mui/material/Grid";
import { useEffect, useState } from "react";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";

// Material Dashboard 2 React examples
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import DefaultInfoCard from "examples/Cards/InfoCards/DefaultInfoCard";
import { apiPatchPointConfig, apiGetPointConfig } from "../../api/point.api";
import { IPointConfig } from '../../constants/types/';
import {useData} from '../../hooks'
import TopNavbar from "examples/Navbars/TopNavbar";

const Config = () => {
  const [pointConfig, setPointConfig] = useState(null);
  const [loading, setLoading] = useState(false);
  const {user, appIsReady} = useData();

  useEffect(() => {
    if (appIsReady && user) {
      fetchPointConfig();
    }
  }, [user, appIsReady]);


  const fetchPointConfig = async () => {
    setLoading(true);
    try {
      const response = await apiGetPointConfig(user.accessToken);
      if (response && response.data) {
        console.log("point config response=", response.data);
        setPointConfig(response.data);
      } else {
        console.log('No data received');
      }
    } catch (error) {
      console.error('Failed to load point config:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleSave = async (key, value) => {
    if (pointConfig) {
      const updatedConfig = {
        ...pointConfig,
        [key]: parseFloat(value),
      };
      setPointConfig(updatedConfig);

      try {
        await apiPatchPointConfig(updatedConfig, user.accessToken);
      } catch (error) {
        console.error('Failed to update point config:', error);
      }
    }
  };

  return (
    <DashboardLayout>
      <TopNavbar absolute isMini />
      <MDBox mt={8}>
        <MDBox mb={3}>
          <Grid container spacing={3}>
            <Grid item xs={12} lg={8}>
              <Grid container mb={3} spacing={3}>
                {pointConfig && (
                  <>
                    <Grid item xs={12} md={6} xl={4}>
                      <DefaultInfoCard
                        color="dark"
                        icon="account_balance"
                        title="R->M 전환 비율"
                        description="전환시 적용되는 비율(모든 사용자 동일)"
                        value={pointConfig.point_convert_rate.toString()}
                        onSave={(value) => handleSave("point_convert_rate", value)}
                      />
                    </Grid>
                    <Grid item xs={12} md={6} xl={4}>
                      <DefaultInfoCard
                        color="primary"
                        icon="send"
                        title="회원간 포인트 전송 1/0"
                        description="모든 회원에 대한 포인트 전송 여부(1:가능,0:불가)"
                        value={pointConfig.receivable}
                        onSave={(value) => handleSave("receivable", value)}
                      />
                    </Grid>
                  </>
                )}
              </Grid>
              
              <Grid container spacing={3}>
                {pointConfig && (
                  <>
                    <Grid item xs={12} md={6} xl={4}>
                      <DefaultInfoCard
                        color="success"
                        icon="attach_money"
                        title="(일반) R Point / Pet"
                        description="펫1개당 적립 RPoint"
                        value={pointConfig.rpoint_pet.toString()}
                        onSave={(value) => handleSave("rpoint_pet", value)}
                      />
                    </Grid>
                    <Grid item xs={12} md={6} xl={4}>
                      <DefaultInfoCard
                        color="success"
                        icon="monetization_on"
                        title="(일반) M Point / Pet"
                        description="펫1개당 적립 MPoint"
                        value={pointConfig.mpoint_pet.toString()}
                        onSave={(value) => handleSave("mpoint_pet", value)}
                      />
                    </Grid>
                    <Grid item xs={12} md={6} xl={4}>
                      <DefaultInfoCard
                        color="secondary"
                        icon="attach_money"
                        title="(지점) R Point / Pet"
                        description="펫1개당 적립 RPoint"
                        value={pointConfig.branch_rpoint_pet.toString()}
                        onSave={(value) => handleSave("branch_rpoint_pet", value)}
                      />
                    </Grid>
                    <Grid item xs={12} md={6} xl={4}>
                      <DefaultInfoCard
                        color="secondary"
                        icon="monetization_on"
                        title="(지점) M Point / Pet"
                        description="펫1개당 적립되는 MPoint"
                        value={pointConfig.branch_mpoint_pet.toString()}
                        onSave={(value) => handleSave("branch_mpoint_pet", value)}
                      />
                    </Grid>
                    <Grid item xs={12} md={6} xl={4}>
                      <DefaultInfoCard
                        color="warning"
                        icon="attach_money"
                        title="(소유주) R Point / Pet"
                        description="펫1개당 적립 RPoint"
                        value={pointConfig.owner_rpoint_pet.toString()}
                        onSave={(value) => handleSave("owner_rpoint_pet", value)}
                      />
                    </Grid>
                    <Grid item xs={12} md={6} xl={4}>
                      <DefaultInfoCard
                        color="warning"
                        icon="monetization_on"
                        title="(소유주) M Point / Pet"
                        description="1개당 적립 MPoint"
                        value={pointConfig.owner_mpoint_pet.toString()}
                        onSave={(value) => handleSave("owner_mpoint_pet", value)}
                      />
                    </Grid>
                    
                  </>
                )}
              </Grid>
            </Grid>
          </Grid>
        </MDBox>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default Config;
